import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiFormHelperText from "@mui/material/FormHelperText";
import InputAdornment from "@mui/material/InputAdornment";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerLocalization from "../../controller/Localization";
import ControllerPayerProfile from "../../controller/custom/PayerProfile";
import ViewLoader from "../Loader";

let isRendered = false;

const viewPagePayerProfile: React.FC = () => {
    // Variable
    const controllerPayerProfile = new ControllerPayerProfile(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerPayerProfile.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerPayerProfile.getSelectOption && controllerPayerProfile.getValidationForm) {
        return (
            <div className="view_payer_profile form" data-at_id="view_payer_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerPayerProfile.getDataMain) {
                        html.push(
                            <div>
                                <div>
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        html.push(
                                            <div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value disabled"
                                                        name="id"
                                                        label={controllerLocalization.getStorageMain.id}
                                                        defaultValue={controllerPayerProfile.getDataMain.id || ""}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value date"
                                                        data-at_id="input_latest_update"
                                                        name="latest_update"
                                                        label={controllerLocalization.getStorageMain.latest_update}
                                                        value={
                                                            controllerPayerProfile.getDataMain.latest_update
                                                                ? HelperSrc.localeFormat(new Date(controllerPayerProfile.getDataMain.latest_update))
                                                                : ""
                                                        }
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_latest_update_by_id"
                                                        name="latest_update_by_id"
                                                        label={controllerLocalization.getStorageMain.latest_update_by}
                                                        defaultValue={(() => {
                                                            for (const optionData of Object.values(
                                                                controllerPayerProfile.getSelectOption.latest_update_by_id
                                                            )) {
                                                                const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                                if (
                                                                    controllerPayerProfile.getDataMain.latest_update_by_id === optionDataTyped.value
                                                                ) {
                                                                    return optionDataTyped.display_name;
                                                                }
                                                            }
                                                        })()}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                            </div>
                                        );

                                        return html;
                                    })()}
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(controllerPayerProfile.getSelectOption.client_id)) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerPayerProfile.getElementClientIdValue === "" && controllerPayerProfile.getDataMain
                                                        ? controllerPayerProfile.getDataMain.client_id
                                                        : controllerPayerProfile.getElementClientIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(controllerPayerProfile.getSelectOption.client_id)) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_client_id"
                                                        required={
                                                            controllerPayerProfile.getValidationForm
                                                                ? controllerPayerProfile.getValidationForm.client_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => {
                                                            HelperSrc.checkRegexSelect(event.target.name, event.target.value);
                                                        }}
                                                        label={
                                                            controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.client : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="client_id"
                                                        defaultValue={
                                                            controllerPayerProfile.getElementClientIdValue === "" &&
                                                            controllerPayerProfile.getDataMain
                                                                ? controllerPayerProfile.getDataMain.client_id !== undefined
                                                                    ? controllerPayerProfile.getDataMain.client_id
                                                                    : ""
                                                                : controllerPayerProfile.getElementClientIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerPayerProfile.setElementClientIdValue) {
                                                    controllerPayerProfile.setElementClientIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_bank_name"
                                            name="bank_name"
                                            label={controllerLocalization.getStorageMain.bank_name}
                                            defaultValue={controllerPayerProfile.getDataMain.bank_name || ""}
                                            required={controllerPayerProfile.getValidationForm.bank_name.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.bank_name.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.bank_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_branch_name"
                                            name="branch_name"
                                            label={controllerLocalization.getStorageMain.branch_name}
                                            defaultValue={controllerPayerProfile.getDataMain.branch_name || ""}
                                            required={controllerPayerProfile.getValidationForm.branch_name.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.branch_name.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.branch_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_bank_code"
                                            name="bank_code"
                                            label={controllerLocalization.getStorageMain.bank_code}
                                            defaultValue={controllerPayerProfile.getDataMain.bank_code || ""}
                                            required={controllerPayerProfile.getValidationForm.bank_code.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.bank_code.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.bank_code.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_branch_code"
                                            name="branch_code"
                                            label={controllerLocalization.getStorageMain.branch_code}
                                            defaultValue={controllerPayerProfile.getDataMain.branch_code || ""}
                                            required={controllerPayerProfile.getValidationForm.branch_code.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.branch_code.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.branch_code.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(controllerPayerProfile.getSelectOption.account_type_id)) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerPayerProfile.getElementAccountTypeIdValue === "" && controllerPayerProfile.getDataMain
                                                        ? controllerPayerProfile.getDataMain.account_type_id
                                                        : controllerPayerProfile.getElementAccountTypeIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(controllerPayerProfile.getSelectOption.account_type_id)) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_account_type_id"
                                                        required={
                                                            controllerPayerProfile.getValidationForm
                                                                ? controllerPayerProfile.getValidationForm.account_type_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => {
                                                            HelperSrc.checkRegexSelect(event.target.name, event.target.value);
                                                        }}
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.account_type_id
                                                                : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="account_type_id"
                                                        defaultValue={
                                                            controllerPayerProfile.getElementAccountTypeIdValue === "" &&
                                                            controllerPayerProfile.getDataMain
                                                                ? controllerPayerProfile.getDataMain.account_type_id !== undefined
                                                                    ? controllerPayerProfile.getDataMain.account_type_id
                                                                    : ""
                                                                : controllerPayerProfile.getElementAccountTypeIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerPayerProfile.setElementAccountTypeIdValue) {
                                                    controllerPayerProfile.setElementAccountTypeIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_ac_number"
                                            name="ac_number"
                                            label={controllerLocalization.getStorageMain.ac_number}
                                            defaultValue={controllerPayerProfile.getDataMain.ac_number || ""}
                                            required={controllerPayerProfile.getValidationForm.ac_number.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.ac_number.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.ac_number.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_account_name"
                                            name="account_name"
                                            label={controllerLocalization.getStorageMain.account_name}
                                            defaultValue={controllerPayerProfile.getDataMain.account_name || ""}
                                            required={controllerPayerProfile.getValidationForm.account_name.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.account_name.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.account_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_account_name_kanji"
                                            name="account_name_kanji"
                                            label={controllerLocalization.getStorageMain.account_name_kanji}
                                            defaultValue={controllerPayerProfile.getDataMain.account_name_kanji || ""}
                                            required={controllerPayerProfile.getValidationForm.account_name_kanji.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.account_name_kanji.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.account_name_kanji.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_swift"
                                            name="swift"
                                            label={controllerLocalization.getStorageMain.swift}
                                            defaultValue={controllerPayerProfile.getDataMain.swift || ""}
                                            required={controllerPayerProfile.getValidationForm.swift.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.swift.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.swift.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_url"
                                            name="url"
                                            label={controllerLocalization.getStorageMain.url}
                                            defaultValue={controllerPayerProfile.getDataMain.url || ""}
                                            required={controllerPayerProfile.getValidationForm.url.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.url.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.url.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_amount_transaction"
                                            name="amount_transaction"
                                            label={controllerLocalization.getStorageMain.amount_transaction}
                                            defaultValue={controllerPayerProfile.getDataMain.amount_transaction || ""}
                                            required={controllerPayerProfile.getValidationForm.amount_transaction.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.amount_transaction.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.amount_transaction.error_msg
                                                    );
                                                }
                                            }}
                                            slotProps={{
                                                input: {
                                                    startAdornment: (
                                                        <InputAdornment position="start" className="form_money_icon">
                                                            ￥
                                                        </InputAdornment>
                                                    )
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.is_active}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_active"
                                            name="is_active"
                                            defaultChecked={controllerPayerProfile.getDataMain.is_active || false}
                                            required={controllerPayerProfile.getValidationForm.is_active.required}
                                            onChange={(event) => {
                                                if (controllerPayerProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayerProfile.getValidationForm.is_active.regex_pattern,
                                                        controllerPayerProfile.getValidationForm.is_active.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_update"
                                            disabled={controllerPayerProfile.getApiLoadingList.profileChange}
                                            onClick={(event) => {
                                                controllerPayerProfile.clickChange(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerPayerProfile.getApiLoadingList.profileChange) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPagePayerProfile;
